export const SUPPORT_TICKET_STATUSES = {
  OPEN: 'OPEN',
  IN_PROGRESS: 'IN_PROGRESS',
  WAITING_FOR_USER: 'WAITING_FOR_USER',
  RESOLVED: 'RESOLVED',
  CLOSED: 'CLOSED',
};

export const SUPPORT_REPLY_ACTIONS = {
  KEEP_STATUS: 'KEEP_STATUS',
  REOPEN: 'REOPEN',
  CLOSE: 'CLOSE',
};

export const SUPPORT_TICKET_PRIORITIES = {
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  HIGH: 'HIGH',
  CRITICAL: 'CRITICAL',
};

export const SUPPORT_ISSUE_CATEGORIES = {
  USER_MANAGEMENT: 'USER_MANAGEMENT',
  INVENTORY_TAG: 'INVENTORY_TAG',
  RFID_MAPPING: 'RFID_MAPPING',
  LOGS: 'LOGS',
  CONTROLLER: 'CONTROLLER',
  DEVICE_OFFLINE: 'DEVICE_OFFLINE',
  ACCESS_ISSUE: 'ACCESS_ISSUE',
  LOGIN_AUTH: 'LOGIN_AUTH',
  REPORTING: 'REPORTING',
  TAG_RELATED: 'TAG_RELATED',
  ACCOUNT_RELATED: 'ACCOUNT_RELATED',
  BILLING_RELATED: 'BILLING_RELATED',
  VEHICLE_RELATED: 'VEHICLE_RELATED',
  APP_TECHNICAL: 'APP_TECHNICAL',
  OTHER: 'OTHER',
};

export const SUPPORT_RELATED_MODULES = {
  USERS: 'USERS',
  INVENTORY: 'INVENTORY',
  LOGS: 'LOGS',
  CONTROLLERS: 'CONTROLLERS',
  SOCIETIES: 'SOCIETIES',
  SOCIETY_ADMINS: 'SOCIETY_ADMINS',
  SETTINGS: 'SETTINGS',
  OTHER: 'OTHER',
};

export const SUPPORT_STATUS_LABELS = {
  [SUPPORT_TICKET_STATUSES.OPEN]: 'Open',
  [SUPPORT_TICKET_STATUSES.IN_PROGRESS]: 'In Progress',
  [SUPPORT_TICKET_STATUSES.WAITING_FOR_USER]: 'Waiting for User',
  [SUPPORT_TICKET_STATUSES.RESOLVED]: 'Resolved',
  [SUPPORT_TICKET_STATUSES.CLOSED]: 'Closed',
};

export const SUPPORT_PRIORITY_LABELS = {
  [SUPPORT_TICKET_PRIORITIES.LOW]: 'Low',
  [SUPPORT_TICKET_PRIORITIES.MEDIUM]: 'Medium',
  [SUPPORT_TICKET_PRIORITIES.HIGH]: 'High',
  [SUPPORT_TICKET_PRIORITIES.CRITICAL]: 'Critical',
};

export const SUPPORT_CATEGORY_LABELS = {
  [SUPPORT_ISSUE_CATEGORIES.USER_MANAGEMENT]: 'User Management',
  [SUPPORT_ISSUE_CATEGORIES.INVENTORY_TAG]: 'Inventory Tag',
  [SUPPORT_ISSUE_CATEGORIES.RFID_MAPPING]: 'RFID Mapping',
  [SUPPORT_ISSUE_CATEGORIES.LOGS]: 'Logs',
  [SUPPORT_ISSUE_CATEGORIES.CONTROLLER]: 'Controller',
  [SUPPORT_ISSUE_CATEGORIES.DEVICE_OFFLINE]: 'Device Offline',
  [SUPPORT_ISSUE_CATEGORIES.ACCESS_ISSUE]: 'Access Issue',
  [SUPPORT_ISSUE_CATEGORIES.LOGIN_AUTH]: 'Login/Auth',
  [SUPPORT_ISSUE_CATEGORIES.REPORTING]: 'Reporting',
  [SUPPORT_ISSUE_CATEGORIES.TAG_RELATED]: 'Tag / FASTag',
  [SUPPORT_ISSUE_CATEGORIES.ACCOUNT_RELATED]: 'Account',
  [SUPPORT_ISSUE_CATEGORIES.BILLING_RELATED]: 'Billing',
  [SUPPORT_ISSUE_CATEGORIES.VEHICLE_RELATED]: 'Vehicle',
  [SUPPORT_ISSUE_CATEGORIES.APP_TECHNICAL]: 'App Issue',
  [SUPPORT_ISSUE_CATEGORIES.OTHER]: 'Other',
};

export const SUPPORT_RELATED_MODULE_LABELS = {
  [SUPPORT_RELATED_MODULES.USERS]: 'Users',
  [SUPPORT_RELATED_MODULES.INVENTORY]: 'Inventory',
  [SUPPORT_RELATED_MODULES.LOGS]: 'Logs',
  [SUPPORT_RELATED_MODULES.CONTROLLERS]: 'Controllers',
  [SUPPORT_RELATED_MODULES.SOCIETIES]: 'Societies',
  [SUPPORT_RELATED_MODULES.SOCIETY_ADMINS]: 'Society Admins',
  [SUPPORT_RELATED_MODULES.SETTINGS]: 'Settings',
  [SUPPORT_RELATED_MODULES.OTHER]: 'Other',
};

export const SUPPORT_STATUS_TRANSITIONS = {
  [SUPPORT_TICKET_STATUSES.OPEN]: [
    SUPPORT_TICKET_STATUSES.IN_PROGRESS,
    SUPPORT_TICKET_STATUSES.WAITING_FOR_USER,
    SUPPORT_TICKET_STATUSES.RESOLVED,
  ],
  [SUPPORT_TICKET_STATUSES.IN_PROGRESS]: [
    SUPPORT_TICKET_STATUSES.WAITING_FOR_USER,
    SUPPORT_TICKET_STATUSES.RESOLVED,
  ],
  [SUPPORT_TICKET_STATUSES.WAITING_FOR_USER]: [
    SUPPORT_TICKET_STATUSES.IN_PROGRESS,
    SUPPORT_TICKET_STATUSES.RESOLVED,
  ],
  [SUPPORT_TICKET_STATUSES.RESOLVED]: [SUPPORT_TICKET_STATUSES.CLOSED],
  [SUPPORT_TICKET_STATUSES.CLOSED]: [],
};

export const SUPPORT_ALLOWED_MIME_TYPES = ['image/png', 'image/jpeg'];
export const SUPPORT_MAX_ATTACHMENTS = 5;
export const SUPPORT_MAX_ATTACHMENT_SIZE_BYTES = 5 * 1024 * 1024;

export const getSupportReplyActionOptions = (status) => {
  if (status === SUPPORT_TICKET_STATUSES.RESOLVED) {
    return [
      {
        value: SUPPORT_REPLY_ACTIONS.KEEP_STATUS,
        label: 'Keep ticket resolved',
      },
      {
        value: SUPPORT_REPLY_ACTIONS.REOPEN,
        label: 'Reopen ticket',
      },
      {
        value: SUPPORT_REPLY_ACTIONS.CLOSE,
        label: 'Close ticket',
      },
    ];
  }

  return [
    {
      value: SUPPORT_REPLY_ACTIONS.KEEP_STATUS,
      label: 'Keep current status',
    },
  ];
};

export const getSupportStatusSx = (status) => {
  switch (status) {
    case SUPPORT_TICKET_STATUSES.OPEN:
      return { bgcolor: '#F8D7DA', color: '#B02A37' };
    case SUPPORT_TICKET_STATUSES.IN_PROGRESS:
      return { bgcolor: '#CFF4FC', color: '#0AA2C0' };
    case SUPPORT_TICKET_STATUSES.WAITING_FOR_USER:
      return { bgcolor: '#FFF3CD', color: '#997404' };
    case SUPPORT_TICKET_STATUSES.RESOLVED:
      return { bgcolor: '#BFECD7', color: '#146C43' };
    case SUPPORT_TICKET_STATUSES.CLOSED:
      return { bgcolor: '#DADBDA', color: '#464846' };
    default:
      return { bgcolor: '#FAFAFA', color: '#0E0E0E' };
  }
};

export const formatDateTime = (value) => {
  if (!value) {
    return '-';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  return date.toLocaleString();
};
